import { useMutation } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { toast } from "react-toastify";

const previewLsqTransfer = (payload) =>
    request({
        url: `lsq/admin/transfer/preview`,
        method: "POST",
        data: payload,
    });

const startLsqTransfer = (payload) =>
    request({
        url: `lsq/admin/transfer`,
        method: "POST",
        data: payload,
    });

const usePreviewLsqTransfer = () => {
    return useMutation(
        ["lsq-transfer-preview"],
        (payload) => previewLsqTransfer(payload),
        {
            onSuccess: (response) => {
                if (response?.data?.success === false) {
                    const message = typeof response?.data?.error === "string" && response.data.error
                        ? response.data.error
                        : "Could not preview this transfer.";
                    toast.warn(message);
                }
            },
            onError: () => {
                toast.error("Could not preview this transfer.");
            },
        }
    );
};

const useStartLsqTransfer = () => {
    return useMutation(
        ["lsq-transfer-start"],
        (payload) => startLsqTransfer(payload),
        {
            onSuccess: (response) => {
                if (response?.data?.success === false) {
                    const message = typeof response?.data?.error === "string" && response.data.error
                        ? response.data.error
                        : "Could not start this transfer.";
                    toast.warn(message);
                } else {
                    toast.success("Transfer started.");
                }
            },
            onError: () => {
                toast.error("Could not start this transfer.");
            },
        }
    );
};

export { usePreviewLsqTransfer, useStartLsqTransfer };
